import React from "react";

const WPP: React.FC = () => {
  return (
    <div className="mx-auto px-20 py-16 text-[#1d1d1f] bg-white border">
      <h1 className="text-3xl font-bold mb-6">Introduction</h1>

      <div className="text-xl mb-4">
        Welcome to the privacy policy of Leotus Limited.{" "}
      </div>

      <div className="mb-4 Text dark-blue">
        Leotus Limited respects your privacy and is committed to protecting your
        personal data. This privacy policy will inform you as to how we look
        after your personal data when you visit our website and use our services
        (regardless of where you visit it from) and tell you about your privacy
        rights and how the law protects you.{" "}
      </div>

      <div className="mb-4 Text dark-blue">
        This privacy policy is provided in a layered format so you can click
        through to the specific areas set out below. Please also use the
        Glossary to understand the meaning of some of the terms used in this
        privacy policy.
      </div>

      <div className="mb-4 Text dark-blue">
        <ol className="list-decimal list-outside ml-5 font-bold">
          <li className="mb-2">[IMPORTANT INFORMATION AND WHO WE ARE]</li>

          <li className="mb-2">[THE DATA WE COLLECT ABOUT YOU]</li>

          <li className="mb-2">[HOW IS YOUR PERSONAL DATA COLLECTED?] </li>

          <li className="mb-2">[HOW WE USE YOUR PERSONAL DATA] </li>

          <li className="mb-2">[DISCLOSURES OF YOUR PERSONAL DATA]</li>

          <li className="mb-2">[INTERNATIONAL TRANSFERS] </li>

          <li className="mb-2">[DATA SECURITY]</li>

          <li className="mb-2">[DATA RETENTION] </li>

          <li className="mb-2">[YOUR LEGAL RIGHTS] </li>

          <li className="mb-2">[GLOSSARY]</li>
        </ol>
      </div>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl ">
          1. Important information and who we are
        </div>

        <p className="mb-4 font-bold">Purpose of this privacy policy</p>

        <p className="mb-4">
          This privacy policy aims to give you information on how Leotus Limited
          collects and processes your personal data through your use of this
          website, including any data you may provide through this website when
          you sign up, purchase a product or use one of our services.{" "}
        </p>

        <p className="mb-2">
          This website is not intended for children and we do not knowingly
          collect data relating to children.
        </p>

        <p className="mb-4">
          It is important that you read this privacy policy together with any
          other privacy policy or fair processing policy we may provide on
          specific occasions when we are collecting or processing personal data
          about you so that you are fully aware of how and why we are using your
          data. This privacy policy supplements other notices and privacy
          policies and is not intended to override them.
        </p>

        <p className="mb-4 font-bold">Controller</p>

        <p className="mb-2">
          Leotus Limited is the controller and responsible for your personal
          data (collectively referred to as "Leotus", "we", "us" or "our" in
          this privacy policy).
        </p>

        <p className="mb-4">
          We have appointed a data privacy manager who is responsible for
          overseeing questions in relation to this privacy policy. If you have
          any questions about this privacy policy, including any requests to
          exercise your legal rights, please contact the data privacy manager
          using the details set out below.
        </p>

        <p className="mb-4 font-bold">Contact details</p>

        <p className="mb-2">
          If you have any questions about this privacy policy or our privacy
          practices, please contact our data privacy manager in the following
          ways:
        </p>

        <p className="mb-2"> Full name of legal entity: Leotus Limited</p>

        <p className="mb-2"> Email address: contact@leotus.tech</p>

        <p className="mb-4">
          You have the right to make a complaint at any time to the Gibraltar
          Regulatory Authority as the Information Commissioner's Office in
          Gibraltar (GRA), (www.gra.gi). We would, however, appreciate the
          chance to deal with your concerns before you approach the GRA so
          please contact us in the first instance.{" "}
        </p>

        <p className="mb-4 font-bold">
          Changes to the privacy policy and your duty to inform us of changes
        </p>

        <p className="mb-2">We keep our privacy policy under regular review.</p>

        <p className="mb-4">
          It is important that the personal data we hold about you is accurate
          and current. Please keep us informed if your personal data changes
          during your relationship with us.
        </p>

        <p className="mb-2 font-bold">Third-party links</p>

        <p className="mb-4">
          This website may include links to third-party partners and their
          websites, plug-ins and applications. Clicking on those links or
          enabling those connections may allow these third parties to collect or
          share data about you. We do not control these third-party websites and
          are not responsible for their privacy statements. When you leave our
          website, we encourage you to read the privacy policy of every website
          you visit.
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">
          2. The data we collect about you
        </div>

        <p className="mb-2">
          Personal data, or personal information, means any information about an
          individual from which that person can be identified. It does not
          include data where the identity has been removed (anonymous data).
        </p>

        <p className="mb-2">
          We may collect, use, store and transfer different kinds of personal
          data about you which we have grouped together as follows:
        </p>

        <ul className="list-disc list-inside ml-5 mb-4">
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Identity Data</b> includes first name, last name, username or
            similar identifier, title, date of birth, gender, ID card, Passport
            and tax numbers.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Contact Data</b> includes email and home address and telephone
            numbers.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Financial Data</b> includes bank account and payment card
            details, source of funds proof and source of wealth proof.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Transaction Data</b> includes details about payments to and from
            you and other details of products and services you have purchased
            from us.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Technical Data</b> includes internet protocol (IP) address, your
            login data, browser type and version, time zone setting and
            location, browser plug-in types and versions, operating system and
            platform, and other technology on the devices you use to access this
            website.{" "}
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Profile Data</b> includes your username and password, purchases
            or orders made by you, your interests, preferences, feedback and
            survey responses.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Usage Data </b>includes information about how you use our
            website, products and services.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Marketing and Communications Data</b> includes your preferences
            in receiving marketing from us and our third parties and your
            communication preferences.
          </li>
        </ul>

        <p className="mb-4 Text dark-blue mt-1">
          We also collect, use and share <b>Aggregated Data</b> such as
          statistical or demographic data for any purpose. Aggregated Data could
          be derived from your personal data but is not considered personal data
          in law as this data will not directly or indirectly reveal your
          identity. For example, we may aggregate your Usage Data to calculate
          the percentage of users accessing a specific website feature. However,
          if we combine or connect Aggregated Data with your personal data so
          that it can directly or indirectly identify you, we treat the combined
          data as personal data which will be used in accordance with this
          privacy policy.
        </p>

        <p className="mb-4">
          We do not collect any <b>Special Categories of Personal Data</b> about
          you (this includes details about your race or ethnicity, religious or
          philosophical beliefs, sex life, sexual orientation, political
          opinions, trade union membership, information about your health, and
          genetic and biometric data). However as part of our legal obligations
          regarding Know Your Customer (KYC) requirements, due diligence and
          compliance with anti money laundering and counter terrorism financing
          legislation, we may process criminal convictions and offence data .{" "}
        </p>

        <p className="mb-4 font-bold">If you fail to provide personal data</p>

        <p className="mb-4">
          Where we need to collect personal data by law, or under the terms of a
          contract we have with you, and you fail to provide that data when
          requested, we may not be able to perform the contract we have or are
          trying to enter into with you (for example, to provide you with goods
          or services). In this case, we may have to cancel a product or service
          you have with us but we will notify you if this is the case at the
          time.
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">
          3. How is your personal data collected?
        </div>

        <p className="mb-4">
          We use different methods to collect data from and about you including
          through:
        </p>

        <ul className="list-disc list-inside ml-5 mb-4">
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Direct interactions.</b> You may give us your Identity, Contact,
            Profile and Financial Data by filling in forms or by corresponding
            with us electronically, by post, phone, email or otherwise. This
            includes personal data you provide when you :
            <ul className="list-disc list-inside ml-5">
              <li className="pl-4 Text dark-blue mb-1 mt-1">
                apply for our products or services;
              </li>

              <li className="pl-4 Text dark-blue mb-1 mt-1">
                create an account on our website;
              </li>

              <li className="pl-4 Text dark-blue mb-1 mt-1">
                subscribe to our service or publications;
              </li>

              <li className="pl-4 Text dark-blue mb-1 mt-1">
                request marketing to be sent to you;
              </li>

              <li className="pl-4 Text dark-blue mb-1 mt-1">
                enter a competition, promotion or survey; or
              </li>

              <li className="pl-4 Text dark-blue mb-1 mt-1">
                give us feedback or contact us.
              </li>
            </ul>
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            <b>Third parties or publicly available sources. </b>We will receive
            personal data about you from various third parties and public
            sources as set out below :
          </li>
        </ul>

        <p className="mb-4">Technical Data from the following parties:</p>

        <p className="mb-4">
          (a) analytics providers such as Google based outside Gibraltar;{" "}
        </p>

        <ul className="list-disc list-inside ml-5 mb-4">
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Contact, Financial and Transaction Data from third party partners
            who use our services to pay for their products or services, as well
            as third party service providers of technical, payment and delivery
            services such as <b>UAB “ZEN.COM”</b> based outside Gibraltar.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Identity, Contact and Financial Data from our third party KYC
            service providers we use to comply with our legal obligations under
            applicable KYC, due diligence and anti money laundering and counter
            terrorism financing legislation. This may include criminal
            convictions and offences data.{" "}
          </li>
        </ul>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">
          4. How we use your personal data
        </div>

        <p className="mb-4">
          We will only use your personal data when the law allows us to. Most
          commonly, we will use your personal data in the following
          circumstances:
        </p>

        <ul className="list-disc list-inside ml-5 mb-4">
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Where we need to perform the contract we are about to enter into or
            have entered into with you.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Where we need to comply with a legal obligation
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Where it is necessary for our legitimate interests (or those of a
            third party) and your interests and fundamental rights do not
            override those interests.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Where we obtain your consent.
          </li>
        </ul>

        <p className="mb-4">
          Generally, we do not rely on consent as a legal basis for processing
          your personal data although we will get your consent before sending
          direct marketing communications to you via email or text message. You
          have the right to withdraw consent to marketing at any time by
          contacting us.
        </p>

        <p className="mb-4 font-bold">
          Purposes for which we will use your personal data
        </p>

        <p className="mb-4">
          We have set out below, in a table format, a description of all the
          ways we plan to use your personal data, the type of data used for that
          purpose and which of the legal bases we rely on to do so. We have also
          identified what our legitimate interests are where appropriate.
        </p>

        <p className="mb-4">
          Note that we may process your personal data for more than one lawful
          ground depending on the specific purpose for which we are using your
          data. Please contact us if you need details about the specific legal
          ground we are relying on to process your personal data where more than
          one ground has been set out in the table below.
        </p>

        <table className="table-auto border border-gray-300 w-full text-center mb-4">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-4 py-2">Purpose/Activity</th>

              <th className="border px-4 py-2">Type of data</th>

              <th className="border px-4 py-2">
                Lawful basis for processing including basis of legitimate
                interest
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="border px-4 py-2">
                To register you as a new customer
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity</p>

                <p>(b) Contact</p>
              </td>

              <td className="border px-4 py-2">
                Performance of a contract with you
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To comply with our KYC requirements, due diligence and
                compliance with anti money laundering and counter terrorism
                financing legislation
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity</p>

                <p className="mb-1">(b) Contact</p>

                <p>(c) Financial </p>
              </td>

              <td className="border px-4 py-2">
                Necessary to comply with a legal obligation
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To process and deliver your order including:
                <p className="mb-1 mt-1">
                  (a) Manage payments, fees and charges
                </p>
                <p>(b) Collect and recover money owed to us</p>
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity</p>

                <p className="mb-1">(b) Contact</p>

                <p className="mb-1">(c) Financial </p>

                <p>(d) Transaction </p>
              </td>

              <td className="border px-4 py-2">
                <p className="mb-1">(a) Performance of a contract with you </p>

                <p>
                  (b) Necessary for our legitimate interests (to recover debts
                  due to us)
                </p>
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To manage our relationship with you which will include:
                <p className="mb-1 mt-1">
                  (a) Notifying you about changes to our terms or privacy policy
                </p>
                <p>(b) Asking you to leave a review or take a survey</p>
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity</p>

                <p className="mb-1">(b) Contact</p>

                <p className="mb-1">(c) Profile </p>

                <p>(d) Marketing and Communications </p>
              </td>

              <td className="border px-4 py-2">
                <p className="mb-1">(a) Performance of a contract with you </p>

                <p className="mb-1">
                  (b) Necessary to comply with a legal obligation
                </p>

                <p>
                  (c) Necessary for our legitimate interests (to keep our
                  records updated and to study how customers use our
                  products/services)
                </p>
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To enable you to partake in a prize draw, competition or
                complete a survey
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity</p>

                <p className="mb-1">(b) Contact</p>

                <p className="mb-1">(c) Profile </p>

                <p className="mb-1">(d) Usage </p>

                <p className="mb-1">(e) Marketing and Communications</p>
              </td>

              <td className="border px-4 py-2">
                <p className="mb-1">(a) Performance of a contract with you </p>

                <p>
                  (b) Necessary for our legitimate interests (to study how
                  customers use our products/services, to develop them and grow
                  our business)
                </p>
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To administer and protect our business and this website
                (including troubleshooting, data analysis, testing, system
                maintenance, support, reporting and hosting of data)
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity</p>

                <p className="mb-1">(b) Contact</p>

                <p className="mb-5">(c) Technical </p>
              </td>

              <td className="border px-4 py-2">
                <p className="mb-1">
                  (a) Necessary for our legitimate interests (for running our
                  business, provision of administration and IT services, network
                  security, to prevent fraud and in the context of a business
                  reorganisation or group restructuring exercise)
                </p>

                <p>(b) Necessary to comply with a legal obligation</p>
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To deliver relevant website content and advertisements to you
                and measure or understand the effectiveness of the advertising
                we serve to you
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity</p>

                <p className="mb-1">(b) Contact</p>

                <p className="mb-1">(c) Profile </p>

                <p className="mb-1">(d) Usage </p>

                <p className="mb-1">(e) Marketing and Communications </p>

                <p>(f) Technical </p>
              </td>

              <td className="border px-4 py-2">
                <p className="mb-1">(a) Consent</p>

                <p>
                  (b) Necessary for our legitimate interests (to study how
                  customers use our products/services, to develop them, to grow
                  our business and to inform our marketing strategy)
                </p>
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To use data analytics to improve our website, products/services,
                marketing, customer relationships and experiences
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Technical </p>

                <p className="mb-5">(b) Usage </p>
              </td>

              <td className="border px-4 py-2">
                <p>
                  Necessary for our legitimate interests (to define types of
                  customers for our products and services, to keep our website
                  updated and relevant, to develop our business and to inform
                  our marketing strategy)
                </p>
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To make suggestions and recommendations to you about goods or
                services that may be of interest to you
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity </p>

                <p className="mb-1">(b) Contact </p>

                <p className="mb-1">(c) Technical </p>

                <p className="mb-1">(d) Usage </p>

                <p className="mb-1">(e) Profile </p>

                <p className="mb-1">(f) Marketing and Communications</p>
              </td>

              <td className="border px-4 py-2">
                <p className="mb-1">(a) Consent</p>

                <p>
                  (b) Necessary for our legitimate interests (to develop our
                  products/services and grow our business)
                </p>
              </td>
            </tr>

            <tr>
              <td className="border px-4 py-2">
                To provide you with direct marketing
              </td>

              <td className="border px-4 py-2 flex flex-col">
                <p className="mb-1">(a) Identity </p>

                <p className="mb-1">(b) Contact </p>

                <p className="mb-1">(c) Technical </p>

                <p className="mb-1">(d) Usage </p>

                <p className="mb-1">(e) Profile </p>

                <p className="mb-1">(f) Marketing and Communications</p>
              </td>

              <td className="border px-4 py-2">
                <p>Consent</p>
              </td>
            </tr>
          </tbody>
        </table>

        <p className="mb-2 font-bold">Marketing</p>

        <p className="mb-4">
          We strive to provide you with choices regarding certain personal data
          uses, particularly around marketing and advertising.{" "}
        </p>

        <p className="mb-2 font-bold">Promotional offers from us </p>

        <p className="mb-2">
          We may use your Identity, Contact, Technical, Usage and Profile Data
          to form a view on what we think you may want or need, or what may be
          of interest to you. This is how we decide which products, services and
          offers may be relevant for you (we call this marketing).
        </p>

        <p className="mb-4">
          You will receive marketing communications from us if you have
          requested information from us if you consent to this..
        </p>

        <p className="mb-2 font-bold">Third-party marketing </p>

        <p className="mb-4">
          We will get your express opt-in consent before we share your personal
          data with any third party for marketing purposes.
        </p>

        <p className="mb-2 font-bold">
          Withdrawing Consent to receive marketing
        </p>

        <p className="mb-4">
          You can ask us or third parties to stop sending you marketing messages
          at any time [by logging into the website and checking or unchecking
          relevant boxes to adjust your marketing preferences OR by following
          the opt-out links on any marketing message sent to you OR by
          contacting us at any time].
        </p>

        <p className="mb-2 font-bold">Cookies</p>

        <p className="mb-4">
          [You can visit our control panel to enable or disable certain cookies.
          If you disable or refuse cookies, please note that some parts of this
          website may become inaccessible or not function properly. For more
          information about the cookies we use, please see [LINK TO YOUR COOKIE
          POLICY].]
        </p>

        <p className="mb-2 font-bold">Change of purpose </p>

        <p className="mb-3">
          We will only use your personal data for the purposes for which we
          collected it, unless we reasonably consider that we need to use it for
          another reason and that reason is compatible with the original
          purpose. If you wish to get an explanation as to how the processing
          for the new purpose is compatible with the original purpose, please
          contact us.
        </p>

        <p className="mb-2">
          If we need to use your personal data for an unrelated purpose, we will
          notify you and we will explain the legal basis which allows us to do
          so.
        </p>

        <p className="mb-2">
          Please note that we may process your personal data without your
          knowledge or consent, in compliance with the above rules, where this
          is required or permitted by law.
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">
          5. Disclosures of your personal data
        </div>

        <p className="mb-2">
          We may share your personal data with the parties set out below for the
          purposes set out in the table [Purposes for which we will use your
          personal data] above.
        </p>

        <ul className="list-disc list-inside ml-5 mb-2">
          <li className="pl-4 Text dark-blue mb-1 mt-1">External Third Parties as set out in the [Glossary].</li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Third parties to whom we may choose to sell, transfer or merge parts
            of our business or our assets. Alternatively, we may seek to acquire
            other businesses or merge with them. If a change happens to our
            business, then the new owners may use your personal data in the same
            way as set out in this privacy policy.{" "}
          </li>
        </ul>

        <p className="mb-4">
          We require all third parties to respect the security of your personal
          data and to treat it in accordance with the law. We do not allow our
          third-party service providers to use your personal data for their own
          purposes and only permit them to process your personal data for
          specified purposes and in accordance with our instructions.
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">6. International transfers</div>

        <p className="mb-2">
          Many of our external third parties are based outside Gibraltar so
          their processing of your personal data will involve a transfer of data
          outside Gibraltar.{" "}
        </p>

        <p className="mb-2">
          Whenever we transfer your personal data out of Gibraltar , we ensure a
          similar degree of protection is afforded to it by ensuring at least
          one of the following safeguards is implemented:
        </p>

        <ul className="list-disc list-inside ml-5 mb-2">
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            We will only transfer your personal data to countries that have been
            deemed to provide an adequate level of protection for personal data
            under local law, mainly the UK, the EEA and any other country which
            benefits from UK adequacy regulations.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Where we use certain service providers, we may use specific
            contracts approved for use in Gibraltar which give personal data the
            same protection it has in Gibraltar such as the use of International
            Data Transfer Agreements or Standard Contractual Clauses modified
            for Gibraltar use.
          </li>
        </ul>

        <p className="mb-4">
          Please contact us if you want further information on the specific
          mechanism used by us when transferring your personal data out of
          Gibraltar .
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">7. Data security</div>

        <p className="mb-2">
          We have put in place appropriate security measures to prevent your
          personal data from being accidentally lost, used or accessed in an
          unauthorised way, altered or disclosed. In addition, we limit access
          to your personal data to those employees, agents, contractors and
          other third parties who have a business need to know. They will only
          process your personal data on our instructions and they are subject to
          a duty of confidentiality.
        </p>

        <p className="mb-4">
          We have put in place procedures to deal with any suspected personal
          data breach and will notify you and any applicable regulator of a
          breach where we are legally required to do so.
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">8. Data retention</div>

        <p className="mb-2 font-bold">
          How long will you use my personal data for?
        </p>

        <p className="mb-2">
          We will only retain your personal data for as long as reasonably
          necessary to fulfil the purposes we collected it for, including for
          the purposes of satisfying any legal, regulatory, tax, accounting or
          reporting requirements. We may retain your personal data for a longer
          period in the event of a complaint or until the risk of litigation
          subsides.
        </p>

        <p className="mb-2">
          To determine the appropriate retention period for personal data, we
          consider the amount, nature and sensitivity of the personal data, the
          potential risk of harm from unauthorised use or disclosure of your
          personal data, the purposes for which we process your personal data
          and whether we can achieve those purposes through other means, and the
          applicable legal, regulatory, tax, accounting or other requirements.
        </p>

        <p className="mb-2">
          By law we have to keep basic information about our customers
          (including Contact, Identity, Financial and Transaction Data) for a
          minimum of six years after they cease being customers for tax
          purposes.
        </p>

        <p className="mb-2">
          In some circumstances you can ask us to delete your data: see [your
          legal rights] below for further information.
        </p>

        <p className="mb-2">
          In some circumstances we will anonymise your personal data (so that it
          can no longer be associated with you) for research or statistical
          purposes, in which case we may use this information indefinitely
          without further notice to you.{" "}
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">9. Your legal rights</div>

        <p className="mb-4">
          Under certain circumstances, you have rights under data protection
          laws in relation to your personal data. Please click on the links
          below to find out more about these rights:
        </p>

        <ul className="list-disc list-inside ml-5 mb-4 font-bold">
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            [Request access to your personal data].
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            [Request correction of your personal data].
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            [Request erasure of your personal data].
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            [Object to processing of your personal data].
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            [Request restriction of processing your personal data].
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            [Request transfer of your personal data].
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            [Right to withdraw consent].
          </li>
        </ul>

        <p className="mb-2">
          If you wish to exercise any of the rights set out above, please
          contact us contact@leotus.tech{" "}
        </p>

        <p className="mb-2 font-bold">No fee usually required</p>

        <p className="mb-4">
          You will not have to pay a fee to access your personal data (or to
          exercise any of the other rights). However, we may charge a reasonable
          fee if your request is clearly unfounded, repetitive or excessive.
          Alternatively, we could refuse to comply with your request in these
          circumstances.
        </p>

        <p className="mb-2 font-bold">What we may need from you</p>

        <p className="mb-4">
          We may need to request specific information from you to help us
          confirm your identity and ensure your right to access your personal
          data (or to exercise any of your other rights). This is a security
          measure to ensure that personal data is not disclosed to any person
          who has no right to receive it. We may also contact you to ask you for
          further information in relation to your request to speed up our
          response
        </p>

        <p className="mb-2 font-bold">Time limit to respond</p>

        <p className="mb-4">
          We try to respond to all legitimate requests within one month.
          Occasionally it could take us longer than a month if your request is
          particularly complex or you have made a number of requests. In this
          case, we will notify you and keep you updated.
        </p>
      </section>

      <section className="mb-8 Text dark-blue">
        <div className="mb-4 font-bold text-xl">10. Glossary</div>

        <div className="mb-2 font-bold">LAWFUL BASIS</div>

        <p className="mb-4">
          <b>Legitimate Interest</b> means the interest of our business in
          conducting and managing our business to enable us to give you the best
          service/product and the best and most secure experience. We make sure
          we consider and balance any potential impact on you (both positive and
          negative) and your rights before we process your personal data for our
          legitimate interests. We do not use your personal data for activities
          where our interests are overridden by the impact on you (unless we
          have your consent or are otherwise required or permitted to by law).
          You can obtain further information about how we assess our legitimate
          interests against any potential impact on you in respect of specific
          activities by contacting us.
        </p>

        <p className="mb-2">
          <b>Performance of Contract</b> means processing your data where it is
          necessary for the performance of a contract to which you are a party
          or to take steps at your request before entering into such a contract.
        </p>

        <p className="mb-4">
          <b>Comply with a legal obligation</b> means processing your personal
          data where it is necessary for compliance with a legal obligation that
          we are subject to.
        </p>

        <p className="mb-2 font-bold">THIRD PARTIES</p>

        <p className="mb-2 font-bold">External Third Parties</p>

        <ul className="list-disc list-inside ml-5 mb-4">
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Service providers acting as processors based in France who provide
            IT, Cloud and system administration services.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Professional advisers acting as controllers including lawyers,
            bankers, auditors and insurers based in Gibraltar and the EEA who
            provide consultancy, banking, legal, insurance and accounting
            services.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Income Tax Office , regulators and other authorities based Gibraltar
            who require reporting of processing activities in certain
            circumstances.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Third party fraud prevention agencies engaged by us to prevent,
            investigate or prosecute criminal acts or to exercise or defend
            legal claims
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Third party KYC and due diligence service providers and market
            researchers, engaged by us in order to comply with our legal
            obligations under applicable KYC, due diligence, anti money
            laundering and counter terrorism financing legislation
          </li>
        </ul>

        <p className="mb-4 font-bold">YOUR LEGAL RIGHTS</p>

        <p className="mb-4">You have the right to:</p>

        <p className="mb-2">
          <b>Request access</b> to your personal data (commonly known as a "data
          subject access request"). This enables you to receive a copy of the
          personal data we hold about you and to check that we are lawfully
          processing it.
        </p>

        <p className="mb-2">
          <b>Request correction</b> of the personal data that we hold about you.
          This enables you to have any incomplete or inaccurate data we hold
          about you corrected, though we may need to verify the accuracy of the
          new data you provide to us.
        </p>

        <p className="mb-2">
          <b>Request erasure</b> of your personal data. This enables you to ask
          us to delete or remove personal data where there is no good reason for
          us continuing to process it. You also have the right to ask us to
          delete or remove your personal data where you have successfully
          exercised your right to object to processing (see below), where we may
          have processed your information unlawfully or where we are required to
          erase your personal data to comply with local law. Note, however, that
          we may not always be able to comply with your request of erasure for
          specific legal reasons which will be notified to you, if applicable,
          at the time of your request.
        </p>

        <p className="mb-2">
          <b>Object to processing</b> of your personal data where we are relying
          on a legitimate interest (or those of a third party) and there is
          something about your particular situation which makes you want to
          object to processing on this ground as you feel it impacts on your
          fundamental rights and freedoms. You also have the right to object
          where we are processing your personal data for direct marketing
          purposes. In some cases, we may demonstrate that we have compelling
          legitimate grounds to process your information which override your
          rights and freedoms.
        </p>

        <p className="mb-2">
          <b>Request restriction of processing</b> of your personal data. This
          enables you to ask us to suspend the processing of your personal data
          in the following scenarios:
        </p>

        <ul className="list-disc list-inside ml-5 mb-4">
          <li className="pl-4 Text dark-blue mb-1 mt-1">If you want us to establish the data's accuracy.</li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Where our use of the data is unlawful but you do not want us to
            erase it.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Where you need us to hold the data even if we no longer require it
            as you need it to establish, exercise or defend legal claims.
          </li>

          <li className="pl-4 Text dark-blue mb-1 mt-1">
            You have objected to our use of your data but we need to verify
            whether we have overriding legitimate grounds to use it.
          </li>
        </ul>

        <p className="mb-4">
          <b>Request the transfer</b> of your personal data to you or to a third
          party. We will provide to you, or a third party you have chosen, your
          personal data in a structured, commonly used, machine-readable format.
          Note that this right only applies to automated information which you
          initially provided consent for us to use or where we used the
          information to perform a contract with you.
        </p>

        <p className="mb-4">
          <b>Withdraw consent at any time</b> where we are relying on consent to
          process your personal data. However, this will not affect the
          lawfulness of any processing carried out before you withdraw your
          consent. If you withdraw your consent, we may not be able to provide
          certain products or services to you. We will advise you if this is the
          case at the time you withdraw your consent.
        </p>
      </section>
    </div>
  );
};

export default WPP;
